import { AppChannel, type Channel } from "./channel"

export const appBaseName = "/loginJwt"

export const CONFIG_PARAMS_COOKIE = "APP_CONFIG_PARAMS"

export const arrayCheckbox: Channel[] = [
  AppChannel.AppMobileSuperenalotto,
  AppChannel.AppMobileEuroJackpot,
  AppChannel.AppMobileVinciCasa,
]

export const externalAppId: Channel[] = [
  AppChannel.AppMobileBingo,
  AppChannel.PlaytechNativePokerApp,
  AppChannel.AppMobileMobileSisalIt,
  AppChannel.AppRouletteGiocaOnLine,
  AppChannel.AppMobileNativeCasinoAppPlaytech,
  AppChannel.MobileLotto10ELotto,
]

export enum UploadDocReason {
  SUSPENDED_ACCOUNT = "suspendedAccount",
}
